import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=a45c6904&scoped=true"
import script from "./MyCalendar.vue?vue&type=script&lang=js"
export * from "./MyCalendar.vue?vue&type=script&lang=js"
import style0 from "./MyCalendar.vue?vue&type=style&index=0&id=a45c6904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45c6904",
  null
  
)

export default component.exports